<template>
  <!-- MODULE ACTIVE PROMOTIONS -->
  <v-flex xs12>
    <v-container class="py-0">
      <v-row>
        <v-col cols="12" class="px-1 py-1">
          <v-card color="accent" dark flat>
            <v-card-title class="h6">
              <v-icon medium class="white--text mr-2">mdi-sale</v-icon>
              {{ $t("dashboardCardActionsDiscountsTitle") }}
            </v-card-title>
            <v-card-text
              class="subtitle-2 ma-0 pa-0 px-3 pb-2"
              v-for="(
                item, index
              ) in $store.state.storePromoCode.activePromoCodes.filter(
                (x) => !x.hidden
              )"
              :key="index"
            >
              <v-icon small class="mb-1 white--text">mdi-clock-outline</v-icon>
              {{ daysLeftSince(item.validTo.seconds) }}
              <v-icon small class="mb-1 white--text">mdi-arrow-right</v-icon>
              {{ $t("homeMenuActivePromotionsPart1Text") }}
              <strong class="white--text">{{ item.promoCode }}</strong>
              {{ $t("homeMenuActivePromotionsPart2Text") }}

              <!-- vrsta popusta % / EUR -->
              <span v-if="item.discountType == 'Pct'"
                ><strong class="white--text">{{ item.discount }}%</strong></span
              >
              <span v-else-if="item.discountType == 'Amt'"
                ><strong class="white--text">{{
                  price(item.discount)
                }}</strong></span
              >

              <!-- popust na modul / izdelek -->
              <span v-if="item.module == G_MODULE_ALL"
                >{{ $t("homeMenuActivePromotionsPart3aText") }}!</span
              >
              <span v-else-if="item.module == G_MODULE_PHOTO_ORDER"
                >{{ $t("homeMenuActivePromotionsPart3Text") }}!</span
              >
              <span v-else-if="item.module == G_MODULE_PHOTO_GIFT">
                {{ $t("homeMenuActivePromotionsPart3dText") }}
                <span v-if="item.superCategory != ''">
                  <strong class="white--text">{{
                    item.superCategoryName
                  }}</strong>
                </span>
                <span v-if="item.category != ''">
                  / <strong class="white--text">{{ item.categoryName }}</strong>
                </span>
                <span v-if="item.item != ''">
                  / <strong class="white--text">{{ item.itemName }}</strong>
                </span>
                <span v-if="item.subItem != ''">
                  /
                  <strong class="white--text">{{
                    item.subItemName
                  }}</strong> </span
                >!
              </span>

              <span v-if="item.permanent">
                {{ $t("homeMenuActivePromotionsPart4bText") }}
              </span>
              <span v-else>
                {{ $t("homeMenuActivePromotionsPart4aText") }}
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-flex>
</template>

<script>
import {
  G_MODULE_ALL,
  G_MODULE_PHOTO_GIFT,
  G_MODULE_PHOTO_ORDER,
} from "@/constants";

export default {
  name: "homeMenuActivePromotions",
  created() {
    this.G_MODULE_ALL = G_MODULE_ALL;
    this.G_MODULE_PHOTO_ORDER = G_MODULE_PHOTO_ORDER;
    this.G_MODULE_PHOTO_GIFT = G_MODULE_PHOTO_GIFT;
  },
};
</script>
